import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Upload, X } from 'lucide-react';
export function NewClaimPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      navigate('/claims');
    }, 1500);
  };
  return <CustomerLayout data-id="element-541">
      <div className="max-w-2xl mx-auto space-y-6" data-id="element-542">
        <div className="text-center mb-8" data-id="element-543">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-544">ثبت خسارت جدید</h1>
          <p className="text-gray-500 mt-2" data-id="element-545">
            لطفاً اطلاعات حادثه را با دقت وارد کنید
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-546">
          <Card data-id="element-547">
            <CardHeader data-id="element-548">
              <CardTitle className="text-lg" data-id="element-549">اطلاعات بیمه‌نامه</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-550">
              <Select label="انتخاب بیمه‌نامه" options={[{
              value: '1',
              label: 'بیمه شخص ثالث - پژو ۲۰۶ (۱۲۳۴۵۶۷۸۹)'
            }, {
              value: '2',
              label: 'بیمه بدنه - پژو ۲۰۶ (۴۵۶۱۲۳۷۸۹)'
            }]} required data-id="element-551" />
              <Input label="تاریخ حادثه" placeholder="1403/02/15" required data-id="element-552" />
              <div className="space-y-2" data-id="element-553">
                <label className="text-sm font-medium" data-id="element-554">شرح حادثه</label>
                <textarea className="w-full min-h-[100px] rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2" placeholder="توضیحات کامل در مورد نحوه وقوع حادثه..." required data-id="element-555" />
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-556">
            <CardHeader data-id="element-557">
              <CardTitle className="text-lg" data-id="element-558">مدارک و مستندات</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6" data-id="element-559">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-560">
                <Upload className="h-10 w-10 text-gray-400 mx-auto mb-4" data-id="element-561" />
                <p className="text-sm text-gray-600 font-medium" data-id="element-562">
                  تصاویر صحنه تصادف و مدارک را اینجا رها کنید
                </p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-563">
                  یا برای انتخاب فایل کلیک کنید (حداکثر ۵ مگابایت)
                </p>
              </div>

              <div className="space-y-2" data-id="element-564">
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-md border" data-id="element-565">
                  <span className="text-sm text-gray-600" data-id="element-566">
                    tasvir-khodro-1.jpg
                  </span>
                  <button type="button" className="text-red-500 hover:text-red-600" data-id="element-567">
                    <X className="h-4 w-4" data-id="element-568" />
                  </button>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="flex gap-4" data-id="element-569">
            <Button type="button" variant="outline" className="flex-1" onClick={() => navigate('/claims')} data-id="element-570">
              انصراف
            </Button>
            <Button type="submit" className="flex-1" isLoading={isLoading} data-id="element-571">
              ثبت نهایی خسارت
            </Button>
          </div>
        </form>
      </div>
    </CustomerLayout>;
}